<template>
  <base-filter-expander
    class="price-range-select"
    :title="$t('search.price-preferences')"
    :is-valid="true"
  >
    <span id="second-section-anchor" class="price-range-select__anchor" />
    <payment-type-radio @paymentTypeChange="updatePaymentType($event)" />
    <budget-slider
      v-for="slider in sliders"
      v-show="search.paymentType === slider.type"
      :key="slider.type"
      :min-price="slider.minPrice"
      :max-price="slider.maxPrice"
      :initial-values="slider.priceRange"
      :step="slider.step"
      :is-visible="search.paymentType === slider.type"
      @update-store="updatePriceRange($event)"
    />
  </base-filter-expander>
</template>

<script>
import BaseFilterExpander from "@/components/ui/BaseFilterExpander/BaseFilterExpander.vue";
import PaymentTypeRadio from "@/components/search/PaymentTypeRadio/PaymentTypeRadio.vue";
import BudgetSlider from "@/components/search/BudgetSlider/BudgetSlider.vue";
import { mapState, mapGetters } from "vuex";
import { UPDATE_PRICE_RANGE, UPDATE_PAYMENT_TYPE } from "@/store/mutationTypes";
import { GET_DATA_FROM_API, GET_MAX_PRICE_RANGE } from "@/store/actionTypes";

export default {
  name: "PriceRangeSelect",
  components: {
    BaseFilterExpander,
    PaymentTypeRadio,
    BudgetSlider
  },
  computed: {
    ...mapState(["search"]),
    ...mapGetters(["minimalAndMaximalPrice", "getPriceRange"]),
    sliders() {
      return [
        {
          type: "monthly",
          minPrice: this.minimalAndMaximalPrice.min,
          maxPrice: this.minimalAndMaximalPrice.max,
          priceRange: this.getPriceRange,
          step: 10
        },
        {
          type: "car-price",
          minPrice: this.minimalAndMaximalPrice.min,
          maxPrice: this.minimalAndMaximalPrice.max,
          priceRange: this.getPriceRange,
          step: 250
        }
      ];
    }
  },
  mounted() {
    this.$store.dispatch(GET_MAX_PRICE_RANGE);
  },
  methods: {
    updatePriceRange(prices) {
      this.$store.commit(UPDATE_PRICE_RANGE, prices);
      this.$store.dispatch(GET_DATA_FROM_API);
    },
    updatePaymentType(paymentType) {
      this.$store.commit(UPDATE_PAYMENT_TYPE, paymentType);
      this.$store.dispatch(GET_DATA_FROM_API);
    }
  }
};
</script>

<style lang="scss" scoped>
.price-range-select {
  position: relative;

  &__anchor {
    position: absolute;
    top: -$header-height-mobile;
  }
}

@media screen and (min-width: $media-l) {
  .price-range-select__anchor {
    top: -$header-height-desktop;
  }
}
</style>
